export default function Footer() {
  return (
    <footer
      style={{ backgroundColor: "#163A2A" }}
      className="pt-16 pb-10 px-6 sm:px-10 lg:px-16"
    >
      <div className="max-w-6xl mx-auto">
        <div
          data-testid="footer-brand-wordmark"
          className="text-6xl sm:text-8xl lg:text-[9rem] leading-none mb-10 select-none"
          style={{ fontFamily: "'Playfair Display', serif", fontWeight: 800, color: "#FAF7F2" }}
        >
          Flavrd<span style={{ color: "#8FC69B" }}>.</span>
        </div>
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-8 pt-8" style={{ borderTop: "1px solid rgba(250,247,242,0.12)" }}>
          <div>
            <p className="text-base max-w-xs leading-relaxed mb-4" style={{ color: "rgba(250,247,242,0.6)" }}>
              Everyday Indian food, clean &amp; high in nutrition. High protein, real fiber, zero compromise.
            </p>
            <div className="flex gap-2.5">
              {["Made Fresh in India", "100% Clean Label"].map((b) => (
                <span key={b} className="text-[10px] font-bold uppercase tracking-widest px-3 py-1.5 rounded-full" style={{ backgroundColor: "rgba(143,198,155,0.16)", color: "#8FC69B" }}>
                  {b}
                </span>
              ))}
            </div>
          </div>
          <div className="flex flex-col items-start sm:items-end gap-2">
            <p className="text-xs" style={{ color: "rgba(250,247,242,0.4)" }}>
              © 2026 Flavrd Foods. All rights reserved.
            </p>
            <p className="text-xs tracking-widest uppercase" style={{ color: "rgba(250,247,242,0.3)" }}>
              Made Fresh, In India
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
